import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b7bfe8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-class"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "rls-content" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "rls-point-wrapper"
}
const _hoisted_6 = { class: "rls-point" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "rls-detail-wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid-item rls-wrapper", [
          {'rls-coupon': ($props.item.GiftCoupon ?? 0) === 2},
          $props.item.Tags.split(',').join(' ').toLowerCase()
          ]]),
    "data-class": $props.item.Tags
  }, [
    _createElementVNode("img", {
      class: "rls-img",
      src: $props.item.ImageURL ?? $props.item.BannerURL,
      alt: $props.item.Name
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "rls-name",
        textContent: _toDisplayString($props.item.Name)
      }, null, 8, _hoisted_4),
      ('PointsToRedeem' in $props.item)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_SvgIcon, {
              class: "token",
              "icon-name": "token"
            }),
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode("VIC " + _toDisplayString(_ctx.$t('points')) + ": ", 1),
              _createElementVNode("span", {
                class: "rls-point-redeem",
                textContent: _toDisplayString($props.item.PointsToRedeem.toLocaleString())
              }, null, 8, _hoisted_7)
            ])
          ]))
        : ('Description' in $props.item)
          ? (_openBlock(), _createElementBlock("h5", {
              key: 1,
              class: "rls-description",
              textContent: _toDisplayString($props.item.Description)
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h5", {
          class: _normalizeClass(["fw6", {'o-0': !($props.item.To || $props.item.EffectiveTo)}])
        }, [
          _createTextVNode(_toDisplayString($props.category.toLowerCase() === 'reward' ? _ctx.$t('redemption-until') : _ctx.$t('promotion-until')) + " ", 1),
          _hoisted_10,
          _createElementVNode("span", {
            class: "rls-date",
            textContent: _toDisplayString($props.item.To || $props.item.EffectiveTo || '-')
          }, null, 8, _hoisted_11)
        ], 2),
        _createElementVNode("div", {
          class: "rls-more",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onItemClicked && $setup.onItemClicked(...args)))
        }, [
          _createElementVNode("h4", {
            class: "fw6",
            textContent: _toDisplayString(_ctx.$t('more-detail'))
          }, null, 8, _hoisted_12),
          _createVNode(_component_SvgIcon, {
            class: "arrow-right",
            "icon-name": "arrow-right"
          })
        ])
      ])
    ])
  ], 10, _hoisted_1))
}